import * as React from "react"
import {Link} from "gatsby"
import {} from "./credits.css"

const Credits = () => (
    <div className={`d-flex align-items-center justify-content-between`}>
        <p className={`text-start`}>
            Copyright &#169; Texbond Nonwowens 2021
        </p>
        <p className={`text-end`}>
            Manufactured with <span className="text-orange">
                 ❤
            </span> from India
        </p>
    </div>
)

export default Credits